import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {createBaseQueryArgs} from './api/createBaseQueryArgs';

export const ebsApi = createApi({
  reducerPath: 'ebsApi',
  baseQuery: fetchBaseQuery(createBaseQueryArgs),
  endpoints: () => ({}),
  tagTypes: ['UserPreference', 'Work'],
  // Keep a low cache by default. Cached enpoints are overridden when needed.
  // E.g. thesaurus and codelist
  keepUnusedDataFor: 5,
});
